/**
 * @generated SignedSource<<a6abc619257bd4b04ac4043cacbf27d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceSidebar_productizedService$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCTAs_productizedService" | "ProductizedServiceDetails_productizedService" | "ProductizedServiceIndustries_productizedService" | "ProductizedServicePrice_productizedService" | "ProductizedServiceSkillsTools_productizedService">;
  readonly " $fragmentType": "ProductizedServiceSidebar_productizedService";
};
export type ProductizedServiceSidebar_productizedService$key = {
  readonly " $data"?: ProductizedServiceSidebar_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceSidebar_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceSidebar_productizedService",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServicePrice_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceDetails_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceSkillsTools_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceCTAs_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceIndustries_productizedService"
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "18bb8e7f543bf74d428f54550d01461d";

export default node;
